import {Component,OnInit} from '@angular/core';
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {Condition} from "@domain/workflow/condition";
import {AlerteListItemComponent} from "@components/admin/workflow/conditions/alertes/liste/item/alerte-list-item.component";
import {TranslateService} from "@ngx-translate/core";
import {TypePortee} from "@domain/workflow/workflow";
import {NiveauAlerte} from "@domain/common/alerte/alerte";
import {BehaviorSubject} from 'rxjs';
import {FloatingButtonAction,TypeAction} from '@share/component/floating-button/floating-button';
import {Router} from "@angular/router";
import {Sorting} from "@domain/common/list-view/sorting";

/**
 * Liste des alertes
 */
@Component({
	host: {'data-test-id': 'alerte-list'},
	templateUrl: './alerte-list.component.html'
})
export class AlerteListComponent implements OnInit {
	/** Liste des alertes */
	listeAlertes: ListView<Condition,AlerteListItemComponent>;

	/** Liste des actions possibles */
	listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

	/**
	 * Constructeur
	 *
	 * @param translateService le moteur de traduction
	 * @param router le routeur Angular
	 */
	constructor(
		private translateService: TranslateService,
		private router: Router
	) {
	}

	/**
	 * Initialisation du composant
	 */
	ngOnInit(): void {
		//Initialisation de la liste des alertes
		this.listeAlertes = new ListView<Condition,AlerteListItemComponent>({
			uri: '/controller/Alerte/getListeAlerte',
			title: this.translateService.instant('workflow.conditions.alertes.title'),
			component: AlerteListItemComponent,
			defaultOrder: 'idPortee,libelle',
			isFilter: true,
			listeFilters: [
				{
					clef: 'libelle',
					title: this.translateService.instant('filter.libelle'),
					typeComparaison: TypeComparaison[TypeComparaison.LIKE],
					isDefault: true
				},{
					clef: 'idPortee',
					title: this.translateService.instant('filter.portee'),
					listeValues: [
						{
							code: TypePortee.AV,
							libelle: this.translateService.instant('portee.AV')
						},{
							code: TypePortee.DV,
							libelle: this.translateService.instant('portee.DV')
						},{
							code: TypePortee.FC,
							libelle: this.translateService.instant('portee.FC')
						},{
							code: TypePortee.NF,
							libelle: this.translateService.instant('portee.NF')
						},{
							code: TypePortee.OD,
							libelle: this.translateService.instant('portee.OD')
						},{
							code: TypePortee.OT,
							libelle: this.translateService.instant('portee.OT')
						}
					]
				},{
					clef: 'niveauAlerte',
					title: this.translateService.instant('filter.niveauAlerte'),
					listeValues: [
						{
							code: NiveauAlerte.NO_CONTROL.toString(),
							libelle: this.translateService.instant('workflow.alerte.niveau.0')
						},{
							code: NiveauAlerte.WARNING.toString(),
							libelle: this.translateService.instant('workflow.alerte.niveau.1')
						},{
							code: NiveauAlerte.ERROR.toString(),
							libelle: this.translateService.instant('workflow.alerte.niveau.2')
						}
					]
				}
			]
		});

		//Définition des colonnes de tri
		this.listeAlertes.columns = [
			{key: 'libelle',title: 'filter.libelle'},
			{key: 'idPortee',title: 'filter.portee'}
		];

		//Ajout du tri de la liste
		this.listeAlertes.sorting = new Sorting(this.listeAlertes.columns,'idPortee,libelle');

		//Persistence des filtres
		this.listeAlertes.isPersistFilters = true;
		this.listeAlertes.className = 'AlerteListComponent';

		//Définition de la liste des actions possibles
		this.listeActions.next([{
			type: TypeAction.PRIMARY,
			icone: 'nio icon-ajouter',
			libelle: 'global.actions.creer',
			doAction: () => this.createAlerte()
		}]);
	}

	/**
	 * Appel à la création d'une alerte
	 */
	createAlerte(): void {
		//Redirection vers la page de création d'une alerte
		this.router.navigateByUrl('Admin/Workflow/Conditions/Alerte/0');
	}
}
